import { call, put, takeLatest } from 'redux-saga/effects'
import { defineTypes } from '../helpers'
import KegEndpoint from '../persistence/KegEndpoint'
import ProductsEndpoint from '../persistence/ProductsEndpoint'
import { reduxFetch } from '../http/reduxFetch'
import activeJsonApi from '../json-api'

const inventoryTypes = { ...defineTypes('INVENTORY')  }
export const inventoryStore = new activeJsonApi('inventories')

export const initialState = {
  loading: false,
  loaded: false,
  stocked: false,
  error: {},
  products: [],
  inventories: []
}

export const actions = {
  getInventory () {
    return { type: inventoryTypes.REQUEST }
  },
  toggleStock () {
    return { type: 'TOGGLE_STOCK' }
  }
}

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case inventoryTypes.REQUEST:
      return { ...state, started: true, loading: true }
    case inventoryTypes.DESTROY:
      return { ...state, loading: false }
    case 'TOGGLE_STOCK':
      return { ...state, stocked: !state.stocked }
    case inventoryTypes.FAILURE:
      return { ...state, loading: false, error: action.error }
    case inventoryTypes.SUCCESS:
      return { ...state, loading: false, loaded: true, inventories: action.inventories, products: action.products }
    default:
      return state
  }
}
export const selectors = {
  inventories: (store) => {
    return store['inventory'] && store['inventory']['inventories']
  },
  products: (store) => {
    return store['inventory'] && store['inventory']['products']
  },
  stocked: (store) => {
    return store['inventory'] && store['inventory']['stocked']
  },
  loaded: ({ inventory }) => {
    return inventory && inventory['loaded']
  },
  jsonApiInventory: (product) => {
    let id = product['id']
    return inventoryStore.getIncludedRelationship('inventory', 'product', String(id))
  },
}

export function * inventorySaga () {
  try {
    const products_response = yield call(reduxFetch, ProductsEndpoint.index())
    if (products_response['data'] ) {
      yield put({ type: inventoryTypes.SUCCESS, products: products_response.data })
    } else {
      yield put({ type: inventoryTypes.FAILURE, error: products_response['error'] })
    }
  } catch (error) {
    yield put({ type: inventoryTypes.FAILURE, error })
  }
}

export function * rootSaga () {
  yield takeLatest(inventoryTypes.REQUEST, inventorySaga)
}



// WEBPACK FOOTER //
// ./src/sagas/inventory.js